import React, { Component } from 'react'

import arrowIcon from '../../images/ARROW-F.svg'
import icecreamIcon from '../../images/icecream.png'

export default class ErrorPage extends Component {

    render() {
        return (
            <div className="utility-page-wrap">
                <img alt="" src={icecreamIcon} width={157} sizes="157px" className="image-89" />
                <div className="utility-page-content">
                    <h2 className="heading-24">
                        OOPS!<br />
                        <span className="pagenotfound text-span-3">PAGE&nbsp;NOT FOUND</span>
                    </h2>
                    <div className="text-block-91">
                        The page you are looking for doesn't exist or has been moved.
                    </div>
                    <a href="/" data-w-id="af709185-057c-3efb-9582-6f6838bba061" className="link-block-13 w-hidden-medium w-hidden-small w-hidden-tiny w-inline-block">
                        <img alt="" src={arrowIcon} width={11} data-w-id="556d3fa7-6908-d861-6021-e145d93f5e2b" style={{display: 'none'}} className="image-100" />
                        <div data-w-id="964ae030-6934-5eab-3d80-6e2436990ee2" className="text-block-92">BACK&nbsp;HOME</div>
                    </a>
                    <a href="/" className="link-block-13-mobile w-hidden-main w-inline-block">
                        <img alt="" src={arrowIcon} width={11} className="image-100" />
                        <div className="text-block-92">BACK&nbsp;HOME</div>
                    </a>
                </div>
            </div>
        )
    }
}
